export function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export function toggleInnerText(elm, textArr) {
    if (elm.innerText.trim() == textArr[0]) {
        elm.innerText = textArr[1];
    } else {
        elm.innerText = textArr[0];
    }
}
// make available inside html
window.toggleInnerText = toggleInnerText;
